import type mapboxgl from 'mapbox-gl';

// DOM markers can query fog before Mapbox 2.x has evaluated a replacement
// style's fog properties. These flat fleet maps do not need atmosphere.
export const onFlatMapStyleReady = (map: mapboxgl.Map, onReady: () => void) => {
  const handleStyleLoad = () => {
    map.setFog(null);
    onReady();
  };
  map.on('style.load', handleStyleLoad);
  return () => { map.off('style.load', handleStyleLoad); };
};
